import {MaintainAppConfig} from '@hconnect/common/hproduce/maintain.types'

export const rcfa: MaintainAppConfig = {
  name: 'Maintain',
  displayName: 'RCFA',
  urlAlias: 'rcfa',
  whiteListedPermissionTypes: ['CONTRIBUTE_TO_ROOT_CAUSE_FAILURE_ANALYSES']
}
